import React, { useEffect, useState } from "react";
import WalletIcon from "../../../Images/Group 24.png";
import axios from "../../../axios";
import { errorToast, successToast } from "../../../utils/toast";
import { useUser } from "../../../hooks/use-user";
import { useTranslation } from "react-i18next";
import { FaEdit } from "react-icons/fa";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { useToast } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { IoArrowRedoSharp } from "react-icons/io5";
import { FaArrowUp } from "react-icons/fa";
const ReferralWallet = () => {
  const toast = useToast({ position: "top" });
  const { data: user, refetch } = useUser();
  const [earning, setEarning] = useState(0);

  const [withAmount, setWithAmount] = useState(null);
  const [rate, setRate] = useState(0);
  const [t, i18n] = useTranslation();
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  useEffect(() => {
    if (user) {
      const newUser = user;

      setEarning(Math.round(newUser.totalEarning));
      setRate(newUser?.rate);
    }
  }, [user]);


  const sendWithdrawRequest = (e) => {
    e.preventDefault();
  
    if (withAmount <= 0) {
      toast({
        title: "Please enter an amount greater than 0.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
  
    if (withAmount >= Math.ceil(user?.currentEarning)) {
      toast({
        title: "Insufficient Amount Please Enter Valid Amount.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
  
    axios
      .post("withdrawWalletAmount", {
        amount: +withAmount,
      })
      .then((response) => {
        toast({
          title: "Withdraw request sent successfully.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        setWithAmount(null);
        if (refetch) refetch();
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.message || err.message;
        if (
          errorMessage &&
          errorMessage.includes("pending")
        ) {
          toast({
            title:
              "You already have a pending withdraw request. Please wait until all the pending requests get cleared.",
            status: "warning",
            duration: 4000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Something went wrong. Please try again.",
            status: "error",
            duration: 4000,
            isClosable: true,
          });
        }
        setWithAmount(null);
      });
  };


  const [isFormVisible, setFormVisible] = useState(false);

  const toggleFormVisibility = () => {
    setFormVisible(!isFormVisible);
  };

  const [visibleTooltip, setVisibleTooltip] = useState(null);

 
  const showTooltip = () => {
    setVisibleTooltip(true);
  };

 
  const hideTooltip = () => {
    setVisibleTooltip(null);
  };
  return (
    <div
    
      className="text-bgBlue bg-bgBlue   lg:mt-12 "
    >
      <div className="w-full p-4 flex lg:flex-row flex-col gap-4">
      
        <div className=" relative lg:w-2/3  bg-white rounded-xl ">
        <div className="relative flex justify-end p-2">
          
              <BsFillInfoCircleFill className="text-bgBlue " onMouseEnter={() => showTooltip()}
              onMouseLeave={hideTooltip} size={26}/>
          </div>
          {visibleTooltip ? (
              <div
              
                role="tooltip"
                className="absolute z-10 top-9 right-1 w-72  text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-100 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
        
              >
                <div className="p-2">
                
           <ul
                    style={{ color: '#1C1A4A', listStyleType: 'disc' }}
                    role="list "
                    className= " mb-4 text-left   text-bgBlue"
                  >  
                    <li className="flex items-center  justify-between p-1">
                      
                      <div className="font-bold">
                      ⦿ {t("You can recieve your winning balance in your account within 48 working hours")}
                      </div>
                    </li>
                    
                    <li className="flex items-center  justify-between p-1">
                      
                      <div className="font-bold">
                      ⦿ {t("There Have Negative Marking")}
                      </div>
                    </li>
                    
                    <li className="flex items-center  justify-between p-1">
                     
                      <div className="font-bold">
                      ⦿ {t("Minimum withdrawal amount is 100 Rs")}
                      </div>
                    </li>
                    
                    
                    
                  </ul>
                </div>
              </div>
            ) :null}
            <h1 className="text-2xl text-bgBlue font-extrabold">Referral Wallet</h1>
          <div className="flex justify-center p-1">
            <img src={WalletIcon} alt="" className="w-72 lg:w-96" />
          </div>

          <h1 className="lg:text-start text-center ml-4 lg:text-2xl text-xl font-bold lg:mb-2 p-2">
             Withdraw Your Earning
          </h1>
        
          <div className="  lg:text-start text-center ml-4 lg:text-2xl text-xl font-bold p-2">
            <p>Total Earning : {Math.ceil(user?.contestWalletAmount)} ₹</p>
           
          </div>

          <div className="p-4">
            <form className="max-w-md mx-auto" onSubmit={sendWithdrawRequest}>
              <div className="relative">
                <input
                  type="number"
                  id="default-search"
                  className="block w-full p-3.5  text-sm text-gray-900 border border-gray-300 rounded-full bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter Amount Here..."
                  required
                  value={withAmount || ""}
                  onChange={(e)=>setWithAmount(e.target.value)}
                />
                <button
                  type="submit"
                  className="text-white text-lg absolute end-0 bottom-0 bg-purple hover:bg-bgBlue focus:ring-4 focus:outline-none focus:ring-purple font-medium rounded-full text-sm px-10 py-3.5 dark:bg-purple dark:hover:bg-purple dark:focus:ring-purple"
                >
                  Withdraw
                </button>
              </div>
            </form>
          </div>
          <div className="mb-4 flex lg:flex-row flex-col-reverse lg:justify-between items-center lg:px-4 gap-2">
            <p className="text-sm font-bold text-bgBlue">Minimum Amount Withdraw=100rs</p>
            <Link to={"/dash/withdrawal-history"} className="flex justify-center">
                        <div className="lg:w-40 w-44  flex py-2  justify-center items-center gap-1 rounded-full bg-bgBlue text-white transition duration-300 mt-2 ">
              <button className="font-bold cursor-pointer text-sm">Withdraw History</button>
              <FaArrowUp color="white" className="text-white" size={18} />
            </div>
                        </Link>
          </div>
        </div>
        <div className="lg:w-2/3 border-2 bg-white rounded-xl">
      <div className="flex justify-between p-8">
        <h1 className="text-start text-purple text-2xl font-bold">Bank Details</h1>
        <FaEdit size={26} className="text-purple cursor-pointer" onClick={toggleFormVisibility} />
      </div>

      {(isFormVisible || isLargeScreen) &&(
        <div className="">
          <div className="relative z-0 p-4">
            <input
              type="text"
              id="floating_standard"
              className="py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
            />
            <label
              htmlFor="floating_standard"
              className="absolute p-2 text-sm text-bgBlue dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-4 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-purple peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
            >
              Account Holder Name
            </label>
          </div>
          <div className="relative z-0 p-4">
            <input
              type="text"
              id="floating_standard_2"
              className="py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
            />
            <label
              htmlFor="floating_standard_2"
              className="absolute p-2 text-sm text-bgBlue dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-4 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-purple peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
            >
              Account Number
            </label>
          </div>
          <div className="relative z-0 p-4">
            <input
              type="text"
              id="floating_standard_3"
              className="py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
            />
            <label
              htmlFor="floating_standard_3"
              className="absolute p-2 text-sm text-bgBlue dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-4 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-purple peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
            >
              IFSC Code
            </label>
          </div>
          <div className="relative z-0 p-4">
            <input
              type="text"
              id="floating_standard_4"
              className="py-2.5 px-0 w-full text-sm text-bgBlue bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
            />
            <label
              htmlFor="floating_standard_4"
              className="absolute p-2 text-sm text-bgBlue dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-4 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-purple peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
            >
              Bank Name
            </label>
          </div>
          <div className="relative z-0 p-4">
            <input
              type="text"
              id="floating_standard_5"
              className="py-2.5 px-0 w-full text-sm text-bgBlue bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
            />
            <label
              htmlFor="floating_standard_5"
              className="absolute p-2 text-sm text-bgBlue dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-4 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-purple peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
            >
              Branch Name
            </label>
          </div>
          <div className="p-4 w-full">
            <button
              type="submit"
              className="mt-5 w-1/2 rounded-full bg-purple py-2 text-white"
            >
              Send Details
            </button>
          </div>
        </div>
      )}

      
    </div>
      </div>
    </div>
  );
};

export default ReferralWallet;
